import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import API from '../../../context/API';
import type { RootState } from '../../../redux/store';
import type { Store } from '../store/userStoresSlice';

export const STORES_QUERY_KEY = ['stores'] as const;

export const useStores = () => {
  const { role, loginData } = useSelector((state: RootState) => state.auth);

  return useQuery<Store[]>({
    queryKey: STORES_QUERY_KEY,
    queryFn: async () => {
      if (role === 'admin' && loginData?.id) {
        const res = await API.get(`/stores/by-merchant/${loginData.id}`);
        return res.data.data || [];
      }
      const token = localStorage.getItem('access_token');
      const res = await API.get('/stores', {
        headers: { Authorization: `Bearer ${token}` },
      });
      return res.data.data || [];
    },
    staleTime: 5 * 60 * 1000,
  });
};
